import { render, staticRenderFns } from "./process-page.html?vue&type=template&id=436bbb18&"
import script from "./process-page.js?vue&type=script&lang=js&"
export * from "./process-page.js?vue&type=script&lang=js&"
import style0 from "./process-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports